import { ref, watch } from "vue";
import {
  trackErrorEvent,
  trackingConsent,
} from "../../helper/functions/tracking";

export default function useSharedFormLogic(
  props: any,
  emit: (event: string, ...args: any[]) => void
) {
  const readyForCheck = ref(false);
  const inputValue = ref(props.modelValue);
  const error = ref("");

  function updateValue(): void {
    if (readyForCheck.value) {
      validate(inputValue.value);
      emit("update:modelValue", inputValue.value);
    }
  }

  function validate(value: string | Date): boolean {
    error.value = "";
    if (props.rules) {
      for (const rule of props.rules) {
        const validationResult = rule(value);
        if (validationResult !== true) {
          error.value += validationResult + " | ";
        }
      }
      if (error.value) {
        error.value = error.value.substring(0, error.value.length - 3);
        if (trackingConsent()) {
          trackErrorEvent(props.id, error.value);
        }
        return false;
      } else {
        error.value = "";
        return true;
      }
    }
    return true;
  }

  watch(
    () => props.modelValue,
    (newValue) => {
      inputValue.value = newValue;
    }
  );

  watch(
    () => error.value,
    () => {
      emit("update:error", error.value);
    }
  );

  return {
    readyForCheck,
    inputValue,
    error,
    updateValue,
    validate,
  };
}
